import React from "react";
import {HOME_PAGE} from "../../../../../../config/app-config";
import {Button} from "../../../../../../components/ui/button";
import {ArrowRight} from "lucide-react";


export default function NotFound() {

    function onRedirectClick() {
        window.location.href = HOME_PAGE.route
    }

    return (
        <div className="h-screen w-screen flex flex-col items-center justify-center bg-gray-100">
            <div className="text-center px-4 lg:px-0 max-w-3xl">
                <h1 className="mb-6 text-4xl font-bold text-gray-800 sm:text-5xl">{"Page introuvable"}</h1>
                <p className=" text-gray-600">{"Désolé, nous n'avons pas trouvé la page que vous\n" +
                    "                    recherchiez."}</p>
                <p className="mb-8 text-gray-600">{"Contactez nous si le problème persiste."}</p>
                <Button
                    variant={'primary'}
                    dataId={'redirect-to-homepage'}
                    onClick={onRedirectClick}
                >
                    {"Retourner à l'accueil"}
                    <ArrowRight className={'size-4 ml-2'}/>
                </Button>
            </div>
        </div>
    )
}


